export default (
  state = {
    initialData: null,
    pathAssessments: null,
    pathResult: null,
    focusAssessments: null,
    focusResult: null,
    lifeStyleAssessments: null,
    lifeStyleResult: null,
    lifeStyleLoading: false,
    assessmentsSummary: null,
    learningStyleAssessments: null,
    learningStyleAssessmentQuestions: null,

    selAssessments: null,
    selQuestions: null,
  },
  { type, ...rest },
) => {
  switch (type) {
    case 'ASSESSMENTS/SET_INITIAL_DATA':
      return {
        ...state,
        ...rest,
      };

    case 'ASSESSMENTS/SET_PATH_ASSESSMENTS':
      return {
        ...state,
        ...rest,
      };

    case 'ASSESSMENTS/SET_FOCUS_ASSESSMENTS':
      return {
        ...state,
        ...rest,
      };

    case 'ASSESSMENTS/SET_LIFE_STYLE_ASSESSMENTS':
      return {
        ...state,
        ...rest,
      };

    case 'ASSESSMENTS/RESET_PATH_RESULT':
      return {
        ...state,
        pathResult: null,
      };

    case 'ASSESSMENTS/SET_PATH_RESULT':
      return {
        ...state,
        ...rest,
      };

    case 'ASSESSMENTS/RESET_FOCUS_RESULT':
      return {
        ...state,
        focusResult: null,
      };

    case 'ASSESSMENTS/SET_FOCUS_RESULT':
      return {
        ...state,
        ...rest,
      };

    case 'ASSESSMENTS/RESET_LIFE_STYLE_RESULT':
      return {
        ...state,
        lifeStyleResult: null,
      };

    case 'ASSESSMENTS/SET_LIFE_STYLE_RESULT':
      return {
        ...state,
        ...rest,
      };

    case 'ASSESSMENTS/SET_WYR_RESULT':
      return {
        ...state,
        ...rest,
      };

    case 'ASSESSMENTS/SET_SUMMARY':
      return {
        ...state,
        ...rest,
      };

    case 'ASSESSMENTS/SET_LEARNING_STYLE_ASSESSMENTS':
      return {
        ...state,
        learningStyleAssessments: rest.data,
      };

    case 'ASSESSMENTS/UPDATE_LEARNING_STYLE_ASSESSMENT':
      return {
        ...state,
        learningStyleAssessments: state.learningStyleAssessments.map(
          assessment =>
            assessment.uuid === rest.data.uuid ? rest.data : assessment,
        ),
      };

    case 'ASSESSMENTS/SET_LEARNING_STYLE_ASSESSMENT_QUESTIONS':
      return {
        ...state,
        learningStyleAssessmentQuestions: rest.data,
      };

    case 'ASSESSMENTS/REMOVE_LEARNING_STYLE_ASSESSMENT_QUESTION':
      return {
        ...state,
        learningStyleAssessmentQuestions: state.learningStyleAssessmentQuestions?.filter(
          ({ uuid }) => uuid !== rest.questionUuid,
        ),
      };

    case 'ASSESSMENTS/SET_LIFE_STYLE_LOADING':
      return {
        ...state,
        ...rest,
      };

    case 'ASSESSMENTS/SET_SEL_ASSESSMENTS':
      return {
        ...state,
        selAssessments: rest.data,
      };

    case 'ASSESSMENTS/UPDATE_SEL_ASSESSMENT':
      return {
        ...state,
        selAssessments: state.selAssessments?.map(assessment =>
          assessment.uuid === rest.data.uuid ? rest.data : assessment,
        ),
      };

    case 'ASSESSMENTS/SET_SEL_QUESTIONS':
      return {
        ...state,
        selQuestions: rest.data,
      };

    case 'ASSESSMENTS/REMOVE_SEL_QUESTION':
      return {
        ...state,
        selQuestions: state.selQuestions?.filter(
          ({ uuid }) => uuid !== rest.questionUuid,
        ),
      };

    default:
      return state;
  }
};
